// Firebase configuration object
// Note: These are public configuration values and safe to expose in frontend
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY || "your-api-key",
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || "your-project.firebaseapp.com",
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || "your-project-id",
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || "your-project.appspot.com",
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || "your-sender-id",
  appId: import.meta.env.VITE_FIREBASE_APP_ID || "your-app-id",
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID || "G-XXXXXXXXXX"
};

// Initialize variables for Firebase services
let app: any = null;
let messaging: any = null;
let getToken: any = null;
let onMessage: any = null;

// Dynamic initialization function to avoid import errors when Firebase isn't installed
const initializeFirebase = async () => {
  try {
    // Use dynamic imports to avoid TypeScript errors when Firebase isn't installed
    const firebaseApp = await import('firebase/app');
    const firebaseMessaging = await import('firebase/messaging');
    
    app = firebaseApp.initializeApp(firebaseConfig);
    
    if (typeof window !== 'undefined' && 'serviceWorker' in navigator) {
      messaging = firebaseMessaging.getMessaging(app);
      getToken = firebaseMessaging.getToken;
      onMessage = firebaseMessaging.onMessage;
    }
    
    return { messaging, getToken, onMessage };
  } catch (error) {
    console.error('Error initializing Firebase:', error);
    return { messaging: null, getToken: null, onMessage: null };
  }
};

// Check if Firebase is available
const isFirebaseAvailable = async (): Promise<boolean> => {
  try {
    await import('firebase/app');
    return true;
  } catch {
    return false;
  }
};

export { messaging, getToken, onMessage, initializeFirebase, firebaseConfig, isFirebaseAvailable }; 